<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
    @click:outside="close"
    class="overflow-hidden"
  >
    <v-card flat>
      <v-card-text>
        <v-row>
          <v-col cols="auto" class="px-6">
            <v-img :src="$images.CULTURE_TRACKING_CONGRATS"></v-img>
          </v-col>
          <v-col>
            <div class="text-right">
              <v-btn icon @click="close">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
            <div class="pb-4 text-h5 accent--text font-weight-bold">
              Congratulations!
            </div>
            <div class="pb-4 subtitle-1 font-weight-medium">
              You've successfully setup culture tracking! Your first survey will
              be sent out on {{ scheduledDate | longDateNoTz }} at 9am.
            </div>
            <v-btn color="accent" @click="close">
              Close Message
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "PulseScheduleSuccessDialog",
  components: {},
  props: { scheduledDate: { type: String } },
  data: () => ({
    dialog: false
  }),
  created() {},
  methods: {
    showDialog() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.$emit("close");
    }
  }
};
</script>
